import { useEffect, useRef, useState } from "react";
import Landing from "./components/Landing";
import flower from "./assets/ylwedding.png";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import LanguageSelection from "./components/LanguageSelection";
import Login from "./components/login";
import TicketScan from "./components/TicketScan";

gsap.registerPlugin(ScrollTrigger);

function App() {
  const [isArabic, setIsArabic] = useState(false);
  const [inviteeData, setInviteeData] = useState(null);
  const [languageSelected, setLanguageSelected] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [isLogedin, setIsLogedin] = useState(false);

  const flower1Ref = useRef(null);

  useEffect(() => {
    const fetchInviteeData = async () => {
      try {
        
        // Get the 'invite' query parameter from the URL
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('invite');
        
        const currentUrl = window.location.href

        if (currentUrl.includes('/login')) {
          setIsLogin(true)
        }

        if (token) {
          const usherToken = await localStorage.getItem("usherToken")
          let response = {}
          if(usherToken){
            setIsLogedin(true)
            response = await fetch('https://flokisoft.com/youssefandlara/ticketscan', {
              method: 'POST',
              headers: {
                Authorization: 'ZPJTjkUuhg%',
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ mobileNumber: token, token: usherToken }),
            });

          }else{
          response = await fetch('https://flokisoft.com/youssefandlara/verify_phone', {
            method: 'POST',
            headers: {
              Authorization: 'ZPJTjkUuhg%',
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ mobileNumber: token }),
          });
        }
          const data = await response.json();
          if (data.name) {
            setInviteeData(data);
          } else {
            console.log('Token not found in the invite list');
          }
        } else {
          console.log('No invite token found in the URL');
        }
      } catch (error) {
        console.error('Error fetching invitee data:', error);
      }
    };

    fetchInviteeData();

    // Entrance and swinging animations for the flower images
    gsap.timeline()
      .fromTo(flower1Ref.current, { x: '100vw', opacity: 0, rotation: 10 }, { x: '0vw', opacity: 0.5, duration: 3, rotation: 0, ease: 'power2.out' })

    gsap.to(flower1Ref.current, { rotation: 5, transformOrigin: "bottom center", yoyo: true, repeat: -1, duration: 5, ease: 'power1.inOut' });

   
  }, []);

  const handleLanguageSelection = (lang) => {
    setIsArabic(lang === 'arabic');
    setLanguageSelected(true);
  };

  return (
    <div dir={isArabic ? 'rtl' : 'ltr'} className={`h-[100svh] overflow-hidden ${isArabic ? 'emiratesmedium' : 'RocaRegular'}`}>
        <div ref={flower1Ref} className="z-[-5] fixed right-[-5vw] bottom-[-20%]  h-[70vh] md:h-[150%] md:w-auto  md:right-[-3%] md:bottom-[-50%]">
          <img src={flower} alt="flower" className="object-contain h-full opacity-60" />
        </div>
      

      {/* Pass the required props to Landing */}
       {isLogin?
       <Login />:isLogedin?<TicketScan inviteeData={inviteeData} />:
       languageSelected ?
        <Landing isArabic={isArabic} setIsArabic={setIsArabic} inviteeData={inviteeData} /> :
        <LanguageSelection setLanguage={handleLanguageSelection} />} 
        
        
      
    </div>
  );
}

export default App;
